import { Link } from 'react-router-dom'
import { MapPin, Phone, Mail } from 'lucide-react'
import { STORE } from '@/config/store'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-ink text-white/70 mt-auto">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <p className="font-display uppercase text-3xl leading-none tracking-tight text-white">
              Marine<span className="text-primary-400">Tackle</span>
            </p>
            <p className="mt-2 text-sm text-white/60">{STORE.tagline}</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-primary-400 flex-shrink-0" />
                <span>{STORE.address}</span>
              </li>
              <li>
                <a href={`tel:${STORE.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-white">
                  <Phone className="w-4 h-4 text-primary-400 flex-shrink-0" /> {STORE.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${STORE.email}`} className="flex items-center gap-2 hover:text-white">
                  <Mail className="w-4 h-4 text-primary-400 flex-shrink-0" /> {STORE.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-display uppercase tracking-wide text-white text-lg mb-4">Shop</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white">All products</Link></li>
              <li><Link to="/about" className="hover:text-white">About us</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </div>

          {/* Opening hours */}
          <div>
            <h3 className="font-display uppercase tracking-wide text-white text-lg mb-4">Opening hours</h3>
            <ul className="space-y-1.5 text-sm">
              <li className="flex justify-between"><span>Mon–Fri</span><span className="text-white/90">8:30am – 5pm</span></li>
              <li className="flex justify-between"><span>Saturday</span><span className="text-white/90">8am – 1pm</span></li>
              <li className="flex justify-between"><span>Sunday</span><span className="text-white/50">Closed</span></li>
            </ul>
          </div>

          {/* Dealers */}
          <div>
            <h3 className="font-display uppercase tracking-wide text-white text-lg mb-4">Authorised dealer</h3>
            <div className="flex flex-wrap gap-2">
              {STORE.assets.partners.map((p) => (
                <span key={p.name} className="rounded bg-white/90 px-2 py-1">
                  <img src={p.logo} alt={p.name} className="h-6 w-auto object-contain" />
                </span>
              ))}
            </div>
            <p className="mt-4 text-sm text-white/60">Fast, tracked shipping NZ-wide.</p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p>&copy; {currentYear} {STORE.legalName}. All rights reserved.</p>
          <p className="text-white/40">
            Online store powered by{' '}
            <a href="https://isqroll.co.nz" target="_blank" rel="noreferrer" className="text-white/60 hover:text-white">iSQROLL</a>
          </p>
        </div>
      </div>
    </footer>
  )
}
